import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import DeleteTestButton from "./ActionsButton/DeleteTestButton";
import UpdateTestButton from "./ActionsButton/UpdateTestButton";
import { AdminSwitch } from "../../../../SharedComponents/ListView";
import { applicationTypeEnum } from "../../../../../../Helpers/EnumHelper";
import { UpdateIsArchive, UpdateIsVitrine } from "../../../Inventory/Store/Thunk";
import { getTests } from "../../Store/Thunk";

// Mutation controls (showcase / archive switches + edit + delete) for a test row.
// Rendered as a fragment so the parent can group them in one action cluster.
const RowButtons = React.memo(({ test }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <AdminSwitch
        label={t("vitrine")}
        checked={test.isVitrine}
        onChange={(e) =>
          dispatch(
            UpdateIsVitrine({
              payload: { applicationType: applicationTypeEnum.Test, id: test.id, isVitrine: e.target.checked },
              callback: getTests,
            })
          )
        }
      />
      <AdminSwitch
        label={t("archive")}
        checked={test.isArchive}
        onChange={(e) =>
          dispatch(
            UpdateIsArchive({
              payload: { applicationType: applicationTypeEnum.Test, id: test.id, isArchive: e.target.checked },
              callback: getTests,
            })
          )
        }
      />
      <UpdateTestButton test={test} />
      <DeleteTestButton test={test} />
    </>
  );
});

export default RowButtons;
